import { SearchUrlParamBuilder } from '@/core/utils'
import axios from 'axios'

const URL_PATH = 'api/itemAta/aditamento'

class AditamentoApiClient {
	async buscarHistoricoAditamento(idItemAta, paginacao) {
		let URL = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/historico`,
			filters: { idItemAta: idItemAta },
			pagingAndSorting: paginacao,
		}).build()
		return await axios.get(URL)
	}

	async inserirPercentual(dados) {
		let URL = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/aditar`,
		}).build()
		return await axios.put(URL, dados)
	}
}

export default new AditamentoApiClient()
